///
/// EarthBrowser
///
/// Satellite Browser Feature
///
/// Manages satellite browser window lifecycle and command palette registration
///
/// Created by Matt Giger on December 20, 2025
/// Copyright (c) 2025 Geodata Labs
///

import { useEffect } from 'react'
import { Satellite } from 'lucide-react'
import { SatelliteBrowserRenderer } from '@/components/features/satellite-browser/SatelliteBrowserRenderer'
import { CommandRegistry } from '@/components/features/CommandRegistry'
import { useAppDispatch, useAppSelector } from '@/redux/store'
import { openOrRestoreWindow } from '@/utils/windowUtils'

const SATELLITE_WINDOW_ID = 'satellite-browser'
const SATELLITE_WINDOW_WIDTH = 700
const SATELLITE_WINDOW_HEIGHT = 500

export function SatelliteBrowserFeature() {
	const dispatch = useAppDispatch()
	const datasetWindows = useAppSelector(state => state.dialog.datasetWindows)
	const satelliteWindow = datasetWindows[SATELLITE_WINDOW_ID]

	// Register with command palette
	useEffect(() => {
		const unregister = CommandRegistry.registerFeature({
			id: 'satellite-browser',
			command: {
				id: 'satellites',
				title: 'Satellites',
				icon: <Satellite className="w-4 h-4 text-purple-400" />,
				category: 'Datasets',
				enabled: true,
			onSelect: () => {
				openOrRestoreWindow(
					dispatch,
					datasetWindows,
					SATELLITE_WINDOW_ID,
					{
						id: SATELLITE_WINDOW_ID,
						title: 'Satellites',
						windowType: 'satellite',
						x: 100,
						y: 100,
						width: SATELLITE_WINDOW_WIDTH,
						height: SATELLITE_WINDOW_HEIGHT,
						isMaximized: false,
						isVisible: true,
					}
				)
			}
			},
			renderBrowser: () => null // Not needed for window-based browser
		})

		return unregister
	}, [dispatch, datasetWindows])

	// Render the window if it's open
	if (!satelliteWindow) {
		return null
	}

	return (
		<SatelliteBrowserRenderer
			windowId={SATELLITE_WINDOW_ID}
			windowState={satelliteWindow}
		/>
	)
}

